<div class="container">
  <h1>{{ title }}</h1>
  <span>Seguridad en la información personal de los empleados</span>
  <hr />
</div>
